/**
 * Enum for the different types of data layer categories.
 */
export enum DataLayerCategories {
  Standard = 'standard',
  Upsell = 'upsell',
}
